











import Vue from "vue";

import Markdown from "@/components/Markdown.vue";
import { newDoc } from "@/domain/doc.ts";

export default Vue.extend({
  name: "DocDetail",
  props: {
    repoId: String,
    id: String
  },
  components: {
    Markdown
  },
  data() {
    return {
      doc: newDoc(),
      waiting: false
    };
  },
  watch: {
    id: {
      immediate: true,
      async handler() {
        this.doc = await this.$ioc.docService.getDoc(this.repoId, this.id);
      }
    }
  }
});
